import {
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
} from "ra-friendsofbabba";
import { email, required, useTranslate } from "react-admin";

import React from "react";
import { get } from "lodash";
import { useFormState } from "react-final-form";

const DataForeignInput = (props) => {
  const translate = useTranslate();
  const formState = useFormState({ subscription: { values: true } });
  const isForeign =
    get(formState.values, "venue_type_id", null) === 3 ? true : false;

  if (!isForeign) {
    return null;
  }

  return (
    <Group {...props} wrapper>
      <GroupTitle
        title={translate(
          "resources.executive-project-wp-activities.section.foreign"
        )}
        subTitle={translate(
          "resources.executive-project-wp-activities.section.foreign.help"
        )}
      />
      <Group>
        <GroupItem lg={6}>
          <DebouncedTextInput
            source="foreign_name"
            maxLength={100}
            validate={required()}
          />
        </GroupItem>
        <GroupItem lg={6}>
          <DebouncedTextInput
            maxLength={100}
            source="foreign_venue"
            validate={required()}
            helperText={`resources.executive-project-wp-activities.fields.foreign_venue.help`}
          />
        </GroupItem>
        <GroupItem lg={6}>
          <DebouncedTextInput
            maxLength={100}
            source="foreign_referent_name"
            validate={required()}
            helperText={`resources.executive-project-wp-activities.fields.foreign_referent_name.help`}
          />
        </GroupItem>
        <GroupItem lg={6}>
          <DebouncedTextInput
            maxLength={100}
            source="foreign_referent_email"
            validate={[required(), email()]}
            type="email"
            helperText={`resources.executive-project-wp-activities.fields.foreign_referent_email.help`}
          />
        </GroupItem>
      </Group>
    </Group>
  );
};
export default DataForeignInput;
